import { render, staticRenderFns } from "./create.vue?vue&type=template&id=4848f2d6&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=4848f2d6&prod&lang=scss&scoped=true&"
import style1 from "./create.vue?vue&type=style&index=1&id=4848f2d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4848f2d6",
  null
  
)

export default component.exports